import { styled } from '@mui/material/styles';
import COLORS from '../../styles/theme/colors';

export const Wrap = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '& .sl-reset.map-info-card-container': {
    width: 350
  },

  '.leaflet-popup-pane': {
    display: 'none !important'
  }
});

export const Form = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute', 
  zIndex: '500',
  right: 10, 
  background: 'white',
  marginTop: 40,
  minWidth: 200,
  maxHeight: 'calc(100vh - 100px)',
  overflowY: 'auto'
})

export const FormItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),

  '& .MuiInputLabel-root': {
    fontSize: 12,
    color: COLORS.textSecondColor,
    marginBottom: theme.spacing(0.5),
  },

  '& .MuiSelect-select': {
    padding: '8px 16px',
    borderRadius: 8
  },

  '& .MuiOutlinedInput-root': {
    fontSize: 14,
    borderRadius: 8,
    color: COLORS.textSecondColor,

    '& input': {
      borderRadius: 8,
      color: COLORS.textSecondColor,
      padding: theme.spacing(1, 2),
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 1
      }
    }
  }
}));